var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointerBreifcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9996 10.6013H1V2.20194H13.9996V10.6013ZM8.99973 5.40169H5.99983V7.40154H8.99973V5.40169ZM1.19999 6.00165H5.79984H1.19999ZM9.19972 6.00165H13.7996H9.19972ZM10.1997 1.90196C10.2002 1.73111 10.167 1.56183 10.1018 1.40388C10.0367 1.24593 9.94094 1.10242 9.82012 0.981612C9.6993 0.8608 9.55579 0.765069 9.39783 0.69993C9.23987 0.634791 9.07059 0.601529 8.89973 0.602057H6.49981C6.32895 0.601529 6.15968 0.634791 6.00172 0.69993C5.84376 0.765069 5.70025 0.8608 5.57943 0.981612C5.45861 1.10242 5.36288 1.24593 5.29774 1.40388C5.23259 1.56183 5.19933 1.73111 5.19986 1.90196",
    fill: "#2C2C2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.19999 6.00165H5.79984M9.19972 6.00165H13.7996M10.1997 1.90196C10.2002 1.73111 10.167 1.56183 10.1018 1.40388C10.0367 1.24593 9.94094 1.10242 9.82012 0.981612C9.6993 0.8608 9.55579 0.765069 9.39783 0.69993C9.23987 0.634791 9.07059 0.601529 8.89973 0.602057H6.49981C6.32895 0.601529 6.15968 0.634791 6.00172 0.69993C5.84376 0.765069 5.70025 0.8608 5.57943 0.981612C5.45861 1.10242 5.36288 1.24593 5.29774 1.40388C5.23259 1.56183 5.19933 1.73111 5.19986 1.90196M13.9996 10.6013H1V2.20194H13.9996V10.6013ZM8.99973 5.40169H5.99983V7.40154H8.99973V5.40169Z",
    stroke: "white",
    strokeWidth: 0.599967,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointerBreifcase);
export default __webpack_public_path__ + "static/media/pointer-breifcase.5dca0379c84b10870c6c8222995357b6.svg";
export { ForwardRef as ReactComponent };